import gql from "graphql-tag"
import client from "../../../../../components/ApolloClient"

// GraphQL queries - Using original schemas from ProvidersQuery.js
export const GET_ORGANIZATIONS = gql`
  query getOrganizations($organizationRequest: OrganizationRequest) {
    getOrganizations(organizationRequest: $organizationRequest) {
      content {
        id
        name
        createdAt
        updatedAt
        logoUrl
        isActive
      }
      totalElements
      size
      number
      totalPages
    }
  }
`

export const GET_PLANS = gql`
  query getPlans($planRequest: plansRequest) {
    getPlans(planRequest: $planRequest) {
      plan_name
      file_hash
    }
  }
`

export const GET_PROVIDERS = gql`
  query getProviders($providerRequest: ProviderRequest) {
    getProviders(providerRequest: $providerRequest) {
      content {
        npi
        fullName
      }
      totalElements
      size
      number
      totalPages
    }
  }
`

export const GET_PROVIDER_SERVICE_DETAILS = gql`
  query getProviderServiceDetails($providerServiceDetailsRequest: ProviderServiceDetailsRequest) {
    getProviderServiceDetails(providerServiceDetailsRequest: $providerServiceDetailsRequest) {
      content {
        id
        practitionerNpi
        billingCode
        name
        billingCodeType
        negotiatedRate
        negotiatedType
      }
      totalPages
      totalElements
      last
      number
      size
      numberOfElements
      first
      empty
    }
  }
`

export const GET_SPECIALITIES = gql`
  query getSpecialities($specialityRequest: SpecialityRequest) {
    getSpecialities(specialityRequest: $specialityRequest) {
      content {
        id
        code
        displayName
        section
      }
      totalElements
      size
      number
      totalPages
    }
  }
`

export const GET_SERVICES_LIST = gql`
  query getServicesList($serviceDetailsRequest: ServiceDetailsRequest) {
    getServicesList(serviceDetailsRequest: $serviceDetailsRequest) {
      content {
        id
        serviceName
        billingCode
        billingCodeType
      }
      totalElements
      totalPages
      last
      number
      size
      numberOfElements
    }
  }
`

export const GET_PATIENT_PLAN_INFORMATION = gql`
  query fetchPatientPlanInformationV2 {
    fetchPatientPlanInformationV2 {
      name
      priceTransparencyOrgId
      planName
      fileHash
      fullAddress
    }
  }
`

// V2 API Queries
export const GET_PLANS_V2 = gql`
  query getPlansV2($planRequest: plansRequest) {
    getPlansV2(planRequest: $planRequest) {
      planName
      planUid
    }
  }
`

export const GET_PROVIDER_DETAILS_V2 = gql`
  query getProviderDetailsV2($providerDetailsRequest: ProviderDetailsRequestV2) {
    getProviderDetailsV2(providerDetailsRequest: $providerDetailsRequest) {
      content {
        npi
        fullName
        gender
        specialities
        practiceLocations {
          address
          city
          state
          postalCode
          telephoneNumber
          latitude
          longitude
        }
      }
      serviceCodes {
        serviceCode
        placeOfService
        negotiatedRate
      }
      pageable {
        pageNumber
        pageSize
        sort {
          sorted
          unsorted
          empty
        }
        offset
        paged
        unpaged
      }
      last
      totalPages
      totalElements
      number
      size
      sort {
        sorted
        unsorted
        empty
      }
      first
      numberOfElements
      empty
    }
  }
`

export const GET_PROVIDER_SERVICE_DETAILS_V2 = gql`
  query getProviderServiceDetailsV2($providerServiceDetailsRequest: ProviderServiceDetailsRequest) {
    getProviderServiceDetailsV2(providerServiceDetailsRequest: $providerServiceDetailsRequest) {
      content {
        id
        practitionerNpi
        billingCode
        name
        billingCodeType
        negotiatedRate
        negotiatedType
      }
      totalPages
      totalElements
      last
      number
      size
      numberOfElements
      first
      empty
    }
  }
`

export const GET_PROVIDER_LOCATIONS_V2 = gql`
  query getProviderLocationsV2($providerLocationsRequest: ProviderLocationsRequest) {
    getProviderLocationsV2(providerLocationsRequest: $providerLocationsRequest) {
      content {
        id
        npi
        address
        city
        state
        postalCode
        telephoneNumber
        latitude
        longitude
      }
      pageable {
        pageNumber
        pageSize
        sort {
          sorted
          unsorted
          empty
        }
        offset
        paged
        unpaged
      }
      totalElements
      totalPages
      last
      number
      size
      sort {
        sorted
        unsorted
        empty
      }
      numberOfElements
      first
      empty
    }
  }
`

export const GET_PROVIDER_NEGOTIATED_RATE_FOR_BILLING_CODE_V2 = gql`
  query GetProviderNegotiatedRateForBillingCodeV2(
    $providerServiceDetailsRequest: ProviderServiceDetailsRequest
  ) {
    getProviderNegotiatedRateForBillingCodeV2(
      providerServiceDetailsRequest: $providerServiceDetailsRequest
    ) {
      serviceCode
      serviceName
      negotiatedRate
    }
  }
`

export const FIND_DEDUCTIBLE_VALUE = gql`
  query findDeductibleValue($reqdata: DeductibleValueRequest) {
    findDeductibleValue(deductibleValueRequest: $reqdata) {
      subscriberId
      deductibleValue
    }
  }
`

export const GET_PROVIDER_DETAILS = gql`
  query getProviderDetails($providerDetailsRequest: ProviderDetailsRequest) {
    getProviderDetails(providerDetailsRequest: $providerDetailsRequest) {
      content {
        npi
        fullName
        gender
        enumerationDate
        status
        mailingAddress
        mailingAddressTelephoneNumber
        deactivationDate
        specialities
        practiceLocations {
          address
          city
          state
          postalCode
          telephoneNumber
          latitude
          longitude
        }
      }
      serviceCodes {
        serviceCode
        placeOfService
        negotiatedRate
      }
      pageable {
        pageNumber
        pageSize
        sort {
          sorted
          unsorted
          empty
        }
        offset
        paged
        unpaged
      }
      last
      totalPages
      totalElements
      number
      size
      sort {
        sorted
        unsorted
        empty
      }
      first
      numberOfElements
      empty
    }
  }
`

export const GET_PROVIDER_LOCATIONS = gql`
  query getProviderLocations($providerLocationsRequest: ProviderLocationsRequest) {
    getProviderLocations(providerLocationsRequest: $providerLocationsRequest) {
      content {
        id
        npi
        address
        city
        state
        postalCode
        telephoneNumber
        latitude
        longitude
      }
      pageable {
        pageNumber
        pageSize
        sort {
          sorted
          unsorted
          empty
        }
        offset
        paged
        unpaged
      }
      totalElements
      totalPages
      last
      number
      size
      sort {
        sorted
        unsorted
        empty
      }
      numberOfElements
      first
      empty
    }
  }
`

// Fetch patient plan information for auto-population V2
export const fetchPatientPlanInformationV2 = async () => {
  try {
    const { data } = await client.query({
      query: GET_PATIENT_PLAN_INFORMATION,
      fetchPolicy: "no-cache",
    })

    const patientPlanInfo = data.fetchPatientPlanInformationV2

    if (!patientPlanInfo) {
      return null
    }

    // Transform the response to match the expected format
    return {
      organization: patientPlanInfo.name && patientPlanInfo.priceTransparencyOrgId
        ? {
            id: patientPlanInfo.priceTransparencyOrgId,
            name: patientPlanInfo.name,
          }
        : null,
      plan: patientPlanInfo.planName && patientPlanInfo.fileHash
        ? {
            id: patientPlanInfo.fileHash,
            name: patientPlanInfo.planName,
          }
        : null,
      location: patientPlanInfo.fullAddress
        ? {
            address: patientPlanInfo.fullAddress,
          }
        : null,
    }
  } catch (err) {
    console.error("Error fetching patient plan information:", err)
    return null
  }
}

// Fetch Organizations - Updated to use original format
export const fetchOrganizations = async ({ search = "", page = 1, limit = 20 }) => {
  try {
    const variables = {
      organizationRequest: {
        page: page - 1, // Convert to 0-based indexing
        size: limit,
        search: search,
        sortBy: "",
        direction: "",
      },
    }

    const { data } = await client.query({
      query: GET_ORGANIZATIONS,
      variables,
      fetchPolicy: "no-cache",
    })

    let orgsData = data.getOrganizations
    if (typeof orgsData === "string") {
      try {
        orgsData = JSON.parse(orgsData)
      } catch (e) {
        orgsData = { content: [] }
      }
    }

    const organizations = (orgsData?.content || []).map((org) => ({
      id: org.id,
      name: org.name,
    }))

    return {
      organizations,
      hasMore: organizations.length === limit,
    }
  } catch (err) {
    console.error("Error fetching organizations:", err)
    return { organizations: [], hasMore: false }
  }
}

// Fetch Plans - Updated to use original format
export const fetchPlans = async ({ organizationId, search = "", page = 1, limit = 20 }) => {
  try {
    const variables = {
      planRequest: {
        priceTransparencyOrgId: organizationId,
        planName: search || "",
        page: page - 1, // Convert to 0-based indexing
        size: limit,
      },
    }

    const { data } = await client.query({
      query: GET_PLANS,
      variables,
      fetchPolicy: "no-cache",
    })

    let plansData = data.getPlans
    if (typeof plansData === "string") {
      try {
        plansData = JSON.parse(plansData)
      } catch (e) {
        plansData = []
      }
    }

    const plansArr = Array.isArray(plansData) ? plansData : []
    const plans = plansArr.map((p) => ({
      id: [p.file_hash], // Wrap in array as expected by the original format
      name: p.plan_name,
    }))

    return {
      plans,
      hasMore: plans.length === limit,
    }
  } catch (err) {
    console.error("Error fetching plans:", err)
    return { plans: [], hasMore: false }
  }
}

// Fetch Providers - Updated to use original format
export const fetchProviders = async ({ search = "", page = 1, limit = 20 }) => {
  try {
    const variables = {
      providerRequest: {
        page: page - 1, // Convert to 0-based indexing
        size: limit,
        search: search || "",
        sortBy: "",
        Direction: "", // Note: Capital D as in original
      },
    }

    const { data } = await client.query({
      query: GET_PROVIDERS,
      variables,
      fetchPolicy: "no-cache",
    })

    const providersData = data.getProviders
    const providers = (providersData?.content || []).map((provider) => ({
      id: provider.npi,
      name: provider.fullName,
    }))

    return {
      providers,
      hasMore: providers.length === limit,
    }
  } catch (err) {
    console.error("Error fetching providers:", err)
    return { providers: [], hasMore: false }
  }
}

// Fetch Specialties - Updated to use original format
export const fetchSpecialties = async ({ search = "", page = 1, limit = 20 }) => {
  try {
    const variables = {
      specialityRequest: {
        page: page - 1, // Convert to 0-based indexing
        size: limit,
        search: search || "",
        sortBy: "",
        direction: "",
      },
    }

    const { data } = await client.query({
      query: GET_SPECIALITIES,
      variables,
      fetchPolicy: "no-cache",
    })

    const specialitiesData = data.getSpecialities
    const specialties = (specialitiesData?.content || []).map((specialty) => ({
      id: specialty.code,
      name: specialty.displayName,
    }))

    return {
      specialties,
      hasMore: specialties.length === limit,
    }
  } catch (err) {
    console.error("Error fetching specialties:", err)
    return { specialties: [], hasMore: false }
  }
}

// Fetch Provider Service Details - Updated to use original format
export const fetchProviderServiceDetails = async (npiNumber, fileHash, page = 0, size = 10, serviceName = "") => {
  // Handle fileHash format from original
  const processedFileHash = Array.isArray(fileHash) ? fileHash[0]?.[0] : fileHash
      console.log(processedFileHash, '111111111')
  try {
    const variables = {
      providerServiceDetailsRequest: {
        npiNumber,
        fileHash: processedFileHash,
        page,
        size,
        serviceName,
      },
    }
    
    const { data } = await client.query({
      query: GET_PROVIDER_SERVICE_DETAILS,
      variables,
      fetchPolicy: "no-cache",
    })
    
    return data.getProviderServiceDetails || {}
  } catch (err) {
    console.error("Error fetching provider service details:", err)
    return {}
  }
}

// Updated searchProviders function to use practiceLocations from API response
export const searchProviders = async ({
  organizationId,
  planId,
  location,
  providerId,
  specialtyId,
  distance = 10,
  page = 1,
  limit = 10,
}) => {
  try {
    const processedFileHash = Array.isArray(planId) ? planId[0]?.[0] : planId

    const variables = {
      providerDetailsRequest: {
        latitude: location?.coordinates?.lat?.toString() || "0",
        longitude: location?.coordinates?.lng?.toString() || "0",
        distance: distance.toString(),
        npi: providerId || "",
        taxonomyCode: specialtyId || "",
        serviceCode: "",
        serviceCodeType: "",
        fileHash: processedFileHash,
        page: page - 1,
        size: limit,
      },
    }

    const { data } = await client.query({
      query: GET_PROVIDER_DETAILS,
      variables,
      fetchPolicy: "no-cache",
    })

    const details = data.getProviderDetails
    if (!details?.content) return { providers: [], totalCount: 0, hasMore: false }

    // Map providers with practiceLocations from API response
    const providersWithLocations = details?.content?.map((provider) => {
      // Use practiceLocations from the API response instead of making separate calls
      const locations = (provider?.practiceLocations || []).map((loc) => ({
        address: `${loc?.address}, ${loc?.city}, ${loc?.state} ${loc?.postalCode}`,
        phone: loc?.telephoneNumber,
        coordinates: {
          lat: parseFloat(loc?.latitude),
          lng: parseFloat(loc?.longitude),
        },
      }))

      return {
        id: provider.npi,
        name: provider.fullName,
        npi: provider.npi,
        gender: provider.gender,
        specialties: provider.specialities
          ? provider.specialities.map((s) => ({ name: s.trim() }))
          : [],
        locations,
        inNetwork: true,
        acceptingPatients: true,
      }
    })

    return {
      providers: providersWithLocations,
      totalCount: details.totalElements || 0,
      hasMore: page < (details.totalPages || 0),
    }
  } catch (error) {
    console.error("Error searching providers:", error)
    return { providers: [], totalCount: 0, hasMore: false }
  }
}

// Updated fetchProviderDetailsForDetailsPage to use original format
export const fetchProviderDetailsForDetailsPage = async (providerId) => {
  try {
    const variables = {
      providerDetailsRequest: {
        latitude: "0", // Default values as per original
        longitude: "0",
        distance: "5.0",
        npi: providerId || "",
        taxonomyCode: "",
        serviceCode: "",
        serviceCodeType: "",
        fileHash: "", // Empty for details page
        page: 0,
        size: 1,
      },
    }

    const { data } = await client.query({
      query: GET_PROVIDER_DETAILS,
      variables,
      fetchPolicy: "no-cache",
    })

    const details = data.getProviderDetails
    const providerData = details?.content?.[0]

    if (!providerData) {
      return { provider: null }
    }

    const provider = {
      id: providerData.npi,
      name: providerData.fullName,
      npi: providerData.npi,
      gender: providerData.gender,
      status: providerData.status,
      specialties: providerData.specialities
        ? providerData.specialities?.map((s) => ({ name: s.trim() }))
        : [],
      // Don't include locations here - ProviderDetails will fetch them separately
    }

    return { provider }
  } catch (error) {
    console.error("Error fetching provider details:", error)
    return { provider: null }
  }
}

// Updated fetchProviderServicesForDetailsPage
export const fetchProviderServicesForDetailsPage = async (providerId, fileHash, page = 0, size = 10, serviceName = "") => {
  try {
    // Process fileHash - handle both array and string formats
    const processedFileHash = Array.isArray(fileHash) ? fileHash[0]?.[0] : fileHash
    
    if (!providerId || !processedFileHash) {
      console.warn("Provider ID and fileHash are required for fetching services")
      return { services: [] }
    }

    const variables = {
      providerServiceDetailsRequest: {
        npiNumber: providerId,
        fileHash: processedFileHash,
        page,
        size,
        serviceName: serviceName || "",
      },
    }

    console.log("Fetching provider services with variables:", variables)

    const { data } = await client.query({
      query: GET_PROVIDER_SERVICE_DETAILS,
      variables,
      fetchPolicy: "no-cache",
    })

    const serviceDetails = data.getProviderServiceDetails
    const services = (serviceDetails?.content || []).map((service) => ({
      id: service.id,
      serviceName: service.name,
      procedureCode: service.billingCode,
      negotiatedRate: service.negotiatedRate,
      negotiatedType: service.negotiatedType,
      billingCodeType: service.billingCodeType,
    }))

    return { 
      services,
      hasMore: !serviceDetails?.last,
      totalPages: serviceDetails?.totalPages || 0,
      totalElements: serviceDetails?.totalElements || 0,
    }
  } catch (error) {
    console.error("Error fetching provider services:", error)
    throw error // Re-throw to handle in component
  }
}

// Fetch Provider Locations - Updated to use original format
export const fetchProviderLocations = async (npi, page = 0, size = 10, sortBy = "", direction = "") => {
  try {
    const variables = {
      providerLocationsRequest: {
        npi: npi || "",
        page,
        size,
        sortBy,
        direction,
      },
    }

    const { data } = await client.query({
      query: GET_PROVIDER_LOCATIONS,
      variables,
      fetchPolicy: "no-cache",
    })

    const locationsData = data.getProviderLocations

    return {
      content: locationsData?.content || [],
      hasMore: !locationsData?.last,
      totalPages: locationsData?.totalPages || 0,
      totalElements: locationsData?.totalElements || 0,
      last: locationsData?.last || true,
      number: locationsData?.number || page,
      size: locationsData?.size || size,
      numberOfElements: locationsData?.numberOfElements || 0,
      first: locationsData?.first || page === 0,
      empty: locationsData?.empty || true,
    }
  } catch (err) {
    console.error("Error fetching provider locations:", err)
    return {
      content: [],
      hasMore: false,
      totalPages: 0,
      totalElements: 0,
      last: true,
      number: page,
      size: size,
      numberOfElements: 0,
      first: page === 0,
      empty: true,
    }
  }
}

// Fetch Services - Updated to use original format
export const fetchServices = async ({ search = "", page = 1, limit = 20, searchField = "serviceName" }) => {
  try {
    const variables = {
      serviceDetailsRequest: {
        serviceName: searchField === "serviceName" ? search || "" : "",
        procedureCode: searchField === "procedureCode" ? search || "" : "",
        page: page - 1, // Convert to 0-based indexing
        size: limit,
        sortBy: "",
        Direction: "", // Note: Capital D as in original
      },
    }

    const { data } = await client.query({
      query: GET_SERVICES_LIST,
      variables,
      fetchPolicy: "no-cache",
    })

    const servicesData = data.getServicesList
    const services = (servicesData?.content || []).map((service) => ({
      id: service.id,
      serviceName: service.serviceName,
      billingCode: service.billingCode,
      billingCodeType: service.billingCodeType,
    }))

    return {
      services,
      hasMore: services.length === limit,
    }
  } catch (err) {
    console.error("Error fetching services:", err)
    return { services: [], hasMore: false }
  }
}

// Maintain backward compatibility
export const fetchSpecialitiesLegacy = fetchSpecialties
export const fetchProviderDetailsLegacy = fetchProviderDetailsForDetailsPage

// ============================================
// V2 API Functions
// ============================================

// Fetch Plans V2 - Uses planUid instead of file_hash
export const fetchPlansV2 = async ({ organizationId, organizationName = "", search = "", page = 1, limit = 20 }) => {
  try {
    const variables = {
      planRequest: {
        priceTransparencyOrgId: organizationId,
        organization: organizationName,
        planName: search || "",
        page: page - 1, // Convert to 0-based indexing
        size: limit,
      },
    }

    const { data } = await client.query({
      query: GET_PLANS_V2,
      variables,
      fetchPolicy: "no-cache",
    })

    let plansData = data.getPlansV2
    if (typeof plansData === "string") {
      try {
        plansData = JSON.parse(plansData)
      } catch (e) {
        plansData = []
      }
    }

    const plansArr = Array.isArray(plansData) ? plansData : []
    const plans = plansArr.map((p) => ({
      id: p.planUid, // Now using planUid instead of file_hash array
      name: p.planName,
    }))

    return {
      plans,
      hasMore: plans.length === limit,
    }
  } catch (err) {
    console.error("Error fetching plans V2:", err)
    return { plans: [], hasMore: false }
  }
}

// Search Providers V2 - Uses getProviderDetailsV2 with planUid and name
export const searchProvidersV2 = async ({
  organizationId,
  organizationName = "",
  planId,
  location,
  providerId,
  providerName,
  specialtyId,
  distance = 10,
  page = 1,
  limit = 10,
}) => {
  try {
    const variables = {
      providerDetailsRequest: {
        organization: organizationName,
        latitude: location?.coordinates?.lat?.toString() || "0",
        longitude: location?.coordinates?.lng?.toString() || "0",
        distance: distance.toString(),
        name: providerName || "", // V2 uses provider name instead of NPI
        taxonomyCode: specialtyId || "",
        planUid: planId || "", // V2 uses planUid directly (string)
        page: page - 1,
        size: limit,
      },
    }

    const { data } = await client.query({
      query: GET_PROVIDER_DETAILS_V2,
      variables,
      fetchPolicy: "no-cache",
    })

    const details = data.getProviderDetailsV2
    if (!details?.content) return { providers: [], totalCount: 0, hasMore: false }

    // Map providers with practiceLocations from API response
    const providersWithLocations = details?.content?.map((provider) => {
      // Use practiceLocations from the API response
      const locations = (provider?.practiceLocations || []).map((loc) => ({
        address: `${loc?.address}, ${loc?.city}, ${loc?.state} ${loc?.postalCode}`,
        phone: loc?.telephoneNumber,
        coordinates: {
          lat: parseFloat(loc?.latitude),
          lng: parseFloat(loc?.longitude),
        },
      }))

      return {
        id: provider.npi,
        name: provider.fullName,
        npi: provider.npi,
        gender: provider.gender,
        specialties: provider.specialities
          ? provider.specialities.map((s) => ({ name: s.trim() }))
          : [],
        locations,
        inNetwork: true,
        acceptingPatients: true,
      }
    })

    return {
      providers: providersWithLocations,
      totalCount: details.totalElements || 0,
      hasMore: page < (details.totalPages || 0),
    }
  } catch (error) {
    console.error("Error searching providers V2:", error)
    return { providers: [], totalCount: 0, hasMore: false }
  }
}

// Fetch Provider Services V2 - Uses planUid instead of fileHash
export const fetchProviderServicesV2 = async (npiNumber, planUid, organizationName = "", page = 0, size = 10, serviceName = "") => {
  try {
    if (!npiNumber || !planUid) {
      console.warn("Provider NPI and planUid are required for fetching services V2")
      return { services: [], hasMore: false, totalPages: 0, totalElements: 0 }
    }

    const variables = {
      providerServiceDetailsRequest: {
        organization: organizationName,
        npiNumber,
        planUid, // V2 uses planUid directly (string)
        page,
        size,
        serviceName: serviceName || "",
      },
    }

    console.log("Fetching provider services V2 with variables:", variables)

    const { data } = await client.query({
      query: GET_PROVIDER_SERVICE_DETAILS_V2,
      variables,
      fetchPolicy: "no-cache",
    })

    const serviceDetails = data.getProviderServiceDetailsV2
    const services = (serviceDetails?.content || []).map((service) => ({
      id: service.id,
      serviceName: service.name,
      procedureCode: service.billingCode,
      negotiatedRate: service.negotiatedRate,
      negotiatedType: service.negotiatedType,
      billingCodeType: service.billingCodeType,
    }))

    return { 
      services,
      hasMore: !serviceDetails?.last,
      totalPages: serviceDetails?.totalPages || 0,
      totalElements: serviceDetails?.totalElements || 0,
    }
  } catch (error) {
    console.error("Error fetching provider services V2:", error)
    throw error // Re-throw to handle in component
  }
}

// Fetch Provider Locations V2
export const fetchProviderLocationsV2 = async (npi, organizationName = "", page = 0, size = 10, sortBy = "", direction = "") => {
  try {
    const variables = {
      providerLocationsRequest: {
        organization: organizationName,
        npi: npi || "",
        page,
        size,
        sortBy,
        direction,
      },
    }

    const { data } = await client.query({
      query: GET_PROVIDER_LOCATIONS_V2,
      variables,
      fetchPolicy: "no-cache",
    })

    const locationsData = data.getProviderLocationsV2

    return {
      content: locationsData?.content || [],
      hasMore: !locationsData?.last,
      totalPages: locationsData?.totalPages || 0,
      totalElements: locationsData?.totalElements || 0,
      last: locationsData?.last || true,
      number: locationsData?.number || page,
      size: locationsData?.size || size,
      numberOfElements: locationsData?.numberOfElements || 0,
      first: locationsData?.first || page === 0,
      empty: locationsData?.empty || true,
    }
  } catch (err) {
    console.error("Error fetching provider locations V2:", err)
    return {
      content: [],
      hasMore: false,
      totalPages: 0,
      totalElements: 0,
      last: true,
      number: page,
      size: size,
      numberOfElements: 0,
      first: page === 0,
      empty: true,
    }
  }
}

// Fetch Provider Details V2 - For details page
export const fetchProviderDetailsV2 = async (providerId, organizationName = "") => {
  try {
    const variables = {
      providerDetailsRequest: {
        organization: organizationName,
        latitude: "0",
        longitude: "0",
        distance: "5",
        name: "",
        taxonomyCode: "",
        planUid: "",
        page: 0,
        size: 1,
      },
    }

    const { data } = await client.query({
      query: GET_PROVIDER_DETAILS_V2,
      variables,
      fetchPolicy: "no-cache",
    })

    const details = data.getProviderDetailsV2
    const providerData = details?.content?.[0]

    if (!providerData) {
      return { provider: null }
    }

    const provider = {
      id: providerData.npi,
      name: providerData.fullName,
      npi: providerData.npi,
      gender: providerData.gender,
      specialties: providerData.specialities
        ? providerData.specialities?.map((s) => ({ name: s.trim() }))
        : [],
    }

    return { provider }
  } catch (error) {
    console.error("Error fetching provider details V2:", error)
    return { provider: null }
  }
}

export const GET_INCORRECT_PROVIDER_INFO = gql`
  query saveIncorrectProviderInfo($providerIncorrectInfoRequest: ProviderIncorrectInfoRequest) {
    saveIncorrectProviderInfo(providerIncorrectInfoRequest: $providerIncorrectInfoRequest) {
      id
      providerNpi
      incorrectData
    }
  }
`

export const fetchIncorrectProviderInfo = async ({
  providerNpi,
  incorrectData = [],
}) => {
  try {
    const variables = {
      providerIncorrectInfoRequest: {
        providerNPI: providerNpi,
        incorrectData,
      },
    }

    const { data } = await client.query({
      query: GET_INCORRECT_PROVIDER_INFO,
      variables,
      fetchPolicy: "no-cache",
    })

    // the API returns an array of ProviderIncorrectInfoResponse
    const responses = (data?.saveIncorrectProviderInfo || []).map(item => ({
      id: item.id,
      providerNpi: item.providerNpi,
      incorrectData: item.incorrectData,
    }))

    return responses
  } catch (err) {
    console.error("Error fetching incorrect provider info:", err)
    return []
  }
}

// Fetch Provider Negotiated Rate for Billing Code V2
export const fetchProviderNegotiatedRateForBillingCodeV2 = async ({
  npiNumber,
  planUid,
  billingCode,
  billingClass = "professional",
  organizationName = "",
  page = 0,
  size = 50
}) => {
  try {
    const variables = {
      providerServiceDetailsRequest: {
        organization: organizationName,
        npiNumber,
        planUid,
        billingCode,
        billingClass,
        page,
        size,
      },
    }

    const { data } = await client.query({
      query: GET_PROVIDER_NEGOTIATED_RATE_FOR_BILLING_CODE_V2,
      variables,
      fetchPolicy: "no-cache",
    })

    return data.getProviderNegotiatedRateForBillingCodeV2 || []
  } catch (err) {
    console.error("Error fetching provider negotiated rate for billing code:", err)
    return []
  }
}

// ============================================
// Unauth GraphQL Queries
// ============================================

export const GET_SPECIALITIES_UNAUTH = gql`
  query getSpecialitiesUnauth($specialityRequest: SpecialityRequest) {
    getSpecialitiesUnauth(specialityRequest: $specialityRequest) {
      content {
        id
        code
        displayName
        section
      }
      totalElements
      size
      number
      totalPages
    }
  }
`

export const GET_PROVIDER_DETAILS_UNAUTH = gql`
  query getProviderDetailsUnauth($providerDetailsRequest: ProviderDetailsRequestV2) {
    getProviderDetailsUnauth(providerDetailsRequest: $providerDetailsRequest) {
      content {
        npi
        fullName
        gender
        specialities
        practiceLocations {
          address
          city
          state
          postalCode
          telephoneNumber
          latitude
          longitude
        }
      }
      serviceCodes {
        serviceCode
        placeOfService
        negotiatedRate
      }
      pageable {
        pageNumber
        pageSize
        sort {
          sorted
          unsorted
          empty
        }
        offset
        paged
        unpaged
      }
      last
      totalPages
      totalElements
      number
      size
      sort {
        sorted
        unsorted
        empty
      }
      first
      numberOfElements
      empty
    }
  }
`

export const GET_PROVIDER_SERVICE_DETAILS_UNAUTH = gql`
  query getProviderServiceDetailsUnauth($providerServiceDetailsRequest: ProviderServiceDetailsRequest) {
    getProviderServiceDetailsUnauth(providerServiceDetailsRequest: $providerServiceDetailsRequest) {
      content {
        id
        practitionerNpi
        billingCode
        name
        billingCodeType
        negotiatedRate
        negotiatedType
      }
      totalPages
      totalElements
      last
      number
      size
      numberOfElements
      first
      empty
    }
  }
`

export const GET_PROVIDER_LOCATIONS_UNAUTH = gql`
  query getProviderLocationsUnauth($providerLocationsRequest: ProviderLocationsRequest) {
    getProviderLocationsUnauth(providerLocationsRequest: $providerLocationsRequest) {
      content {
        id
        npi
        address
        city
        state
        postalCode
        telephoneNumber
        latitude
        longitude
      }
      pageable {
        pageNumber
        pageSize
        sort {
          sorted
          unsorted
          empty
        }
        offset
        paged
        unpaged
      }
      totalElements
      totalPages
      last
      number
      size
      sort {
        sorted
        unsorted
        empty
      }
      numberOfElements
      first
      empty
    }
  }
`

export const GET_PROVIDER_NEGOTIATED_RATE_FOR_BILLING_CODE_UNAUTH = gql`
  query getProviderNegotiatedRateForBillingCodeUnauth(
    $providerServiceDetailsRequest: ProviderServiceDetailsRequest
  ) {
    getProviderNegotiatedRateForBillingCodeUnauth(
      providerServiceDetailsRequest: $providerServiceDetailsRequest
    ) {
      serviceCode
      serviceName
      negotiatedRate
    }
  }
`

// Plan UID by network (unauth) — resolves planUid from hostname-derived network name
export const GET_PLAN_UID_BY_NETWORK_UNAUTH = gql`
  query getPlanUidByNetworkUnauth($providerNetwork: String) {
    getPlanUidByNetworkUnauth(providerNetwork: $providerNetwork) {
      planUid
    }
  }
`

// ============================================
// Unauth API Functions
// ============================================

export const fetchSpecialtiesUnauth = async ({ search = "", page = 1, limit = 20 }) => {
  try {
    const variables = {
      specialityRequest: {
        page: page - 1,
        size: limit,
        search: search || "",
        sortBy: "",
        direction: "",
      },
    }
    const { data } = await client.query({
      query: GET_SPECIALITIES_UNAUTH,
      variables,
      fetchPolicy: "no-cache",
    })
    const specialitiesData = data.getSpecialitiesUnauth
    const specialties = (specialitiesData?.content || []).map((specialty) => ({
      id: specialty.code,
      name: specialty.displayName,
    }))
    return { specialties, hasMore: specialties.length === limit }
  } catch (err) {
    console.error("Error fetching specialties (unauth):", err)
    return { specialties: [], hasMore: false }
  }
}

export const searchProvidersUnauth = async ({
  organizationId,
  organizationName = "",
  planId,
  location,
  providerId,
  providerName,
  specialtyId,
  distance = 10,
  page = 1,
  limit = 10,
}) => {
  try {
    const variables = {
      providerDetailsRequest: {
        organization: organizationName,
        latitude: location?.coordinates?.lat?.toString() || "0",
        longitude: location?.coordinates?.lng?.toString() || "0",
        distance: distance.toString(),
        name: providerName || "",
        taxonomyCode: specialtyId || "",
        planUid: planId || "",
        page: page - 1,
        size: limit,
      },
    }
    const { data } = await client.query({
      query: GET_PROVIDER_DETAILS_UNAUTH,
      variables,
      fetchPolicy: "no-cache",
    })
    const details = data.getProviderDetailsUnauth
    if (!details?.content) return { providers: [], totalCount: 0, hasMore: false }
    const providersWithLocations = details.content.map((provider) => {
      const locations = (provider.practiceLocations || []).map((loc) => ({
        address: `${loc.address}, ${loc.city}, ${loc.state} ${loc.postalCode}`,
        phone: loc.telephoneNumber,
        coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitude) },
      }))
      return {
        id: provider.npi,
        name: provider.fullName,
        npi: provider.npi,
        gender: provider.gender,
        specialties: provider.specialities ? provider.specialities.map((s) => ({ name: s.trim() })) : [],
        locations,
        inNetwork: true,
        acceptingPatients: true,
      }
    })
    return {
      providers: providersWithLocations,
      totalCount: details.totalElements || 0,
      hasMore: page < (details.totalPages || 0),
    }
  } catch (error) {
    console.error("Error searching providers (unauth):", error)
    return { providers: [], totalCount: 0, hasMore: false }
  }
}

export const fetchProviderServicesUnauth = async (npiNumber, planUid, organizationName = "", page = 0, size = 10, serviceName = "") => {
  try {
    if (!npiNumber || !planUid) {
      console.warn("Provider NPI and planUid are required for fetching services (unauth)")
      return { services: [], hasMore: false, totalPages: 0, totalElements: 0 }
    }
    const variables = {
      providerServiceDetailsRequest: {
        organization: organizationName,
        npiNumber,
        planUid,
        page,
        size,
        serviceName: serviceName || "",
      },
    }
    const { data } = await client.query({
      query: GET_PROVIDER_SERVICE_DETAILS_UNAUTH,
      variables,
      fetchPolicy: "no-cache",
    })
    const serviceDetails = data.getProviderServiceDetailsUnauth
    const services = (serviceDetails?.content || []).map((service) => ({
      id: service.id,
      serviceName: service.name,
      procedureCode: service.billingCode,
      negotiatedRate: service.negotiatedRate,
      negotiatedType: service.negotiatedType,
      billingCodeType: service.billingCodeType,
    }))
    return {
      services,
      hasMore: !serviceDetails?.last,
      totalPages: serviceDetails?.totalPages || 0,
      totalElements: serviceDetails?.totalElements || 0,
    }
  } catch (error) {
    console.error("Error fetching provider services (unauth):", error)
    throw error
  }
}

export const fetchProviderLocationsUnauth = async (npi, organizationName = "", page = 0, size = 10, sortBy = "", direction = "") => {
  try {
    const variables = {
      providerLocationsRequest: {
        organization: organizationName,
        npi: npi || "",
        page,
        size,
        sortBy,
        direction,
      },
    }
    const { data } = await client.query({
      query: GET_PROVIDER_LOCATIONS_UNAUTH,
      variables,
      fetchPolicy: "no-cache",
    })
    const locationsData = data.getProviderLocationsUnauth
    return {
      content: locationsData?.content || [],
      hasMore: !locationsData?.last,
      totalPages: locationsData?.totalPages || 0,
      totalElements: locationsData?.totalElements || 0,
      last: locationsData?.last || true,
      number: locationsData?.number || page,
      size: locationsData?.size || size,
      numberOfElements: locationsData?.numberOfElements || 0,
      first: locationsData?.first || page === 0,
      empty: locationsData?.empty || true,
    }
  } catch (err) {
    console.error("Error fetching provider locations (unauth):", err)
    return { content: [], hasMore: false, totalPages: 0, totalElements: 0, last: true, number: page, size, numberOfElements: 0, first: page === 0, empty: true }
  }
}

export const fetchProviderNegotiatedRateForBillingCodeUnauth = async ({
  npiNumber,
  planUid,
  billingCode,
  billingClass = "professional",
  organizationName = "",
  page = 0,
  size = 50
}) => {
  try {
    const variables = {
      providerServiceDetailsRequest: {
        organization: organizationName,
        npiNumber,
        planUid,
        billingCode,
        billingClass,
        page,
        size,
      },
    }
    const { data } = await client.query({
      query: GET_PROVIDER_NEGOTIATED_RATE_FOR_BILLING_CODE_UNAUTH,
      variables,
      fetchPolicy: "no-cache",
    })
    return data.getProviderNegotiatedRateForBillingCodeUnauth || []
  } catch (err) {
    console.error("Error fetching provider negotiated rate for billing code (unauth):", err)
    return []
  }
}

export const fetchPlanUidByNetworkUnauth = async (providerNetwork) => {
  try {
    const { data } = await client.query({
      query: GET_PLAN_UID_BY_NETWORK_UNAUTH,
      variables: { providerNetwork },
      fetchPolicy: "no-cache",
    })
    return data.getPlanUidByNetworkUnauth?.planUid || null
  } catch (err) {
    console.error("Error fetching plan UID by network (unauth):", err)
    return null
  }
}

// ============================================
// Adaptive API Functions (Auth vs Unauth routing)
// ============================================

export const fetchSpecialtiesAdaptive = (params, isPublicFlow = false) =>
  isPublicFlow ? fetchSpecialtiesUnauth(params) : fetchSpecialties(params)

export const searchProvidersAdaptive = (params, isPublicFlow = false) =>
  isPublicFlow ? searchProvidersUnauth(params) : searchProvidersV2(params)

export const fetchProviderServicesAdaptive = (npi, planUid, org, page, size, name, isPublicFlow = false) =>
  isPublicFlow ? fetchProviderServicesUnauth(npi, planUid, org, page, size, name) : fetchProviderServicesV2(npi, planUid, org, page, size, name)

export const fetchProviderLocationsAdaptive = (npi, org, page, size, sortBy, dir, isPublicFlow = false) =>
  isPublicFlow ? fetchProviderLocationsUnauth(npi, org, page, size, sortBy, dir) : fetchProviderLocationsV2(npi, org, page, size, sortBy, dir)

export const fetchProviderNegotiatedRateAdaptive = (params, isPublicFlow = false) =>
  isPublicFlow ? fetchProviderNegotiatedRateForBillingCodeUnauth(params) : fetchProviderNegotiatedRateForBillingCodeV2(params)

// Fetch Deductible Value
export const fetchDeductibleValue = async (subscriberIds = []) => {
  try {
    const variables = {
      reqdata: {
        subscriberIds,
      },
    }

    const { data } = await client.query({
      query: FIND_DEDUCTIBLE_VALUE,
      variables,
      fetchPolicy: "no-cache",
    })

    return data.findDeductibleValue || []
  } catch (err) {
    console.error("Error fetching deductible value:", err)
    return []
  }
}